import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import FloatInput from "components/Input/FloatInput";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoint } from "services/ConfigServices";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { pointtext } from "variables/MBM/equipments";
import { stateData, stateNotControlableData, pointeosprotocoleDataSelect, pointliveDataSelect } from "variables/MBM/lists/equipments";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const HeaderId = styled.div`
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function PointDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { groupAccountListById } = appContext;
  const { closeModal, refetch, setNotification, point, equipmentsdata, sessionsdata, globalsessionsdata } = props;
  const [name, setName] = useState(point.name || "");
  const [definition, setDefinition] = useState(point.definition || "");
  const [state, setState] = useState(point.state);
  const [controlable, setControlable] = useState(point.controlable || false);
  const [groupid, setGroups] = useState(point.groupid ? "" + point.groupid : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [syncciteos, setSyncciteos] = useState(point?.connectionproperties?.syncciteos || false);
  const [syncciteosname, setSyncciteosname] = useState(point?.connectionproperties?.syncciteosname || false);
  const [equipment, setEquipment] = useState(point.equipment || "");
  const [eosprotocol, setEosprotocol] = useState(point.connectionproperties?.eosprotocol || "");
  const [url, setUrl] = useState(point.url || "");
  const [type, setType] = useState(point.type || "");
  const [dataname, setDataname] = useState(point.connectionproperties?.dataname || "");
  const [fport, setFport] = useState(point.connectionproperties?.fport || "");
  const [session, setSession] = useState(point.session || "");
  const [conversion, setConversion] = useState(point.conversion || "");
  const [displayproperties, setDisplayproperties] = useState(point.displayproperties ? JSON.stringify(point.displayproperties) : '{}');
  const [controlproperties, setControlproperties] = useState(point.controlproperties ? JSON.stringify(point.controlproperties) : '{}');
  const [alarmproperties, setAlarmproperties] = useState(point.alarmproperties ? JSON.stringify(point.alarmproperties) : '{}');
  const [displaypropertieserror, setDisplaypropertieserror] = useState(false);
  const [controlpropertieserror, setControlpropertieserror] = useState(false);
  const [alarmpropertiesserror, setAlarmpropertieserror] = useState(false);
  const [live, setLive] = useState(point.connectionproperties?.live || 0);

  const dicowithequipmentname = dico.map((row) => {
    let newrow = { ...row };
    newrow.name = row.equipmentname + " - " + row.name + " - " + row.unit + " (" + row.id + ")";
    return newrow;
  });

  const selectedDefinition = () => {
    let selected = dicowithequipmentname.find((obj) => obj.id == definition);
    return selected;
  };

  const handleDefinitionChange = (selected) => { setDefinition(selected?.id || ""); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleStateChange = (event) => { setState(event.target.value); };
  const handleControlableChange = (event) => {
    if (controlable) //if we go to non controlable
    {
      if (state === 1)
        setState(0);//go to viewer if saver
    }
    setControlable(!controlable);
  };
  const handleSyncciteosChange = (e) => {
    setSyncciteos(!syncciteos);
  };
  const handleSyncciteosnameChange = (event) => { setSyncciteosname(event.target.value); };

  const classes = useStyles();

  const selectedEquipment = () => {
    let selected = equipmentsdata.find((obj) => obj.id == equipment);
    return selected;
  };
  const handleEquipmentChange = (selected) => { setEquipment(selected?.id || ""); };
  const handleEosprotocolChange = (event) => { setEosprotocol(event.target.value); };
  const handleUrlChange = (event) => { setUrl(event.target.value); };
  const handleTypeChange = (event) => { setType(event.target.value); };
  const handleDatanameChange = (event) => { setDataname(event.target.value); };
  const handleFportChange = (event) => { setFport(event.target.value); };
  const selectedSession = () => {
    let selected = sessionsdata?.find((obj) => obj.id == session);
    return selected;
  };
  const selectedGlobalsession = () => {
    let selected = globalsessionsdata?.find((obj) => obj.id == session);
    return selected;
  };
  const handleSessionChange = (selected) => { setSession(selected?.id || ""); };
  const handleConversionChange = (event) => { setConversion(event.target.value); };

  const handleDisplaypropertiesChange = (event) => { setDisplayproperties(event.target.value); };
  const handleControlpropertiesChange = (event) => { setControlproperties(event.target.value); };
  const handleAlarmpropertiesChange = (event) => { setAlarmproperties(event.target.value); };
  const handleLiveChange = (event) => { setLive(event.target.value); };


  const handleSubmit = (event) => {
    updatePoint(event);
    closeModal();
  };

  useEffect(() => {
    let buttonDisabledtmp = false;
    try {
      JSON.parse(displayproperties);
      setDisplaypropertieserror(false);
    } catch (error) {
      setDisplaypropertieserror(true);
      buttonDisabledtmp = true;
    }
    try {
      JSON.parse(controlproperties);
      setControlpropertieserror(false);
    } catch (error) {
      setControlpropertieserror(true);
      buttonDisabledtmp = true;
    }
    try {
      JSON.parse(alarmproperties);
      setAlarmpropertieserror(false);
    } catch (error) {
      setAlarmpropertieserror(true);
      buttonDisabledtmp = true;
    }
    if (!name || !definition || !groupid || groupid.length === 0)
      buttonDisabledtmp = true;

    setButtonDisabled(buttonDisabledtmp);
  }, [name, groupid, definition, state, controlable, displayproperties, controlproperties, alarmproperties]);




  const updatePoint = async (event) => {
    let displaypropertiesobj = JSON.parse(displayproperties);
    let controlpropertiesobj = JSON.parse(controlproperties);
    let alarmpropertiesobj = JSON.parse(alarmproperties);
    axios
      .put(
        putPoint("parameters"),
        {
          ...point,
          name,
          definition,
          state,
          controlable,
          groupid,
          url,
          session,
          conversion,
          type,
          connectionproperties:
          {
            ...point.connectionproperties,
            syncciteos,
            syncciteosname,
            eosprotocol,
            dataname,
            fport,
            live,
          },
          displayproperties: displaypropertiesobj,
          controlproperties: controlpropertiesobj,
          alarmproperties: alarmpropertiesobj
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Point modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={4}>
            <HeaderId>Id : {point.id} Point Id : {point.pointid}</HeaderId>
            <div>
              <TextInput
                inputTitle={"Nom"}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={pointtext.definition}
                selected={selectedDefinition()}
                list={dicowithequipmentname}
                handleChange={(_, newValue) =>
                  handleDefinitionChange(newValue)
                }
              />
            </div>
            <div>
              <CustomSwitch
                style={{ margin: "10px 0 0 3px" }}
                inputTitle={pointtext.controlable}
                checkedState={controlable}
                handleSwitchChange={handleControlableChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={pointtext.state}
                selectValue={state}
                handleSelectValueChange={handleStateChange}
                data={controlable ? stateData : stateNotControlableData}
              />
            </div>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={pointtext.equipment}
                selected={selectedEquipment()}
                list={equipmentsdata}
                handleChange={(_, newValue) =>
                  handleEquipmentChange(newValue)
                }
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={pointtext.eosprotocol}
                selectValue={eosprotocol}
                handleSelectValueChange={handleEosprotocolChange}
                data={pointeosprotocoleDataSelect}
              />
            </div>
            {
              (eosprotocol === 'bacnet' || eosprotocol === 'modbus' || eosprotocol === 'modbusip') &&
              <>
                <div>
                  <TextInput
                    inputTitle={pointtext.url}
                    textInput={url}
                    handleTextInputChange={handleUrlChange}
                  />
                </div>
              </>
            }
            {
              (eosprotocol === 'modbus' || eosprotocol === 'modbusip') &&
              <>
                <div>
                  <TextInput
                    inputTitle={pointtext.modbustype}
                    textInput={type}
                    handleTextInputChange={handleTypeChange}
                  />
                </div>
              </>
            }
            {
              (eosprotocol === 'avoblorawanserver' || eosprotocol === 'avoblorawanbox' || eosprotocol === 'orangelorawanserver' || eosprotocol === 'wiotyslorawanserver') &&
              <>
                <div>
                  <TextInput
                    inputTitle={pointtext.dataname}
                    textInput={dataname}
                    handleTextInputChange={handleDatanameChange}
                  />
                </div>
                <div>
                  <TextInput
                    inputTitle={pointtext.fport}
                    textInput={fport}
                    handleTextInputChange={handleFportChange}
                  />
                </div>
              </>
            }
            {
              (eosprotocol === 'avoblorawanbox' || eosprotocol === 'bacnet' || eosprotocol === 'modbus' || eosprotocol === 'modbusip') &&
              <>
                <div>
                  <CustomSelect
                    inputTitle={pointtext.livedata}
                    selectValue={live}
                    handleSelectValueChange={handleLiveChange}
                    data={pointliveDataSelect}
                  />
                </div>
                <div>
                  <AutocompleteInputMeters
                    specialWidth={"97%"}
                    inputMargin={"1rem 0rem 0rem"}
                    inputTitle={pointtext.session}
                    selected={selectedSession()}
                    list={sessionsdata}
                    handleChange={(_, newValue) =>
                      handleSessionChange(newValue)
                    }
                  />
                </div>
              </>
            }
            {
              (eosprotocol === 'avoblorawanserver' || eosprotocol === 'orangelorawanserver' || eosprotocol === 'wiotyslorawanserver') &&
              <>
                <div>
                  <AutocompleteInputMeters
                    specialWidth={"97%"}
                    inputMargin={"1rem 0rem 0rem"}
                    inputTitle={pointtext.session}
                    selected={selectedGlobalsession()}
                    list={globalsessionsdata}
                    handleChange={(_, newValue) =>
                      handleSessionChange(newValue)
                    }
                  />
                </div>
              </>
            }

            <div>
              <FloatInput
                inputTitle={pointtext.conversion}
                floatInput={conversion}
                handleFloatInputChange={handleConversionChange}
              />
            </div>
            {
              groupAccountListById["" + groupid] == 41604 ?
                <>
                  <div>
                    <CustomSwitch
                      style={{ margin: "10px 0 0 3px" }}
                      inputTitle={pointtext.syncciteos}
                      checkedState={syncciteos}
                      handleSwitchChange={handleSyncciteosChange}
                    />
                  </div>
                  {
                    syncciteos ?
                      <div>
                        <TextInput
                          inputTitle={pointtext.syncciteosname}
                          textInput={syncciteosname || ""}
                          handleTextInputChange={handleSyncciteosnameChange}
                        />
                      </div> : <></>
                  }
                </> : <></>
            }
          </GridItem>
          <GridItem xs={12} sm={5} md={5} lg={5}>
            <div>
              <TextInput
                inputTitle={pointtext.displayproperties}
                multiline
                rows={4}
                textInput={displayproperties}
                handleTextInputChange={handleDisplaypropertiesChange}
                error={displaypropertieserror}
              />
            </div>
            <div>
              <TextInput
                inputTitle={pointtext.controlproperties}
                multiline
                rows={4}
                textInput={controlproperties}
                handleTextInputChange={handleControlpropertiesChange}
                error={controlpropertieserror}
              />
            </div>
            <div>
              <TextInput
                inputTitle={pointtext.alarmproperties}
                multiline
                rows={4}
                textInput={alarmproperties}
                handleTextInputChange={handleAlarmpropertiesChange}
                error={alarmpropertiesserror}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={3} md={3} lg={3}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groupid}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form >

    </>
  );
}

export default PointDialog;
